export enum UsersSortBy {
  FULL_NAME = 'fullName',
  EMAIL = 'email',
  CREATED_AT = 'createdAt',
  COMPANIES_COUNT = 'companiesCount',
}
